import { render, staticRenderFns } from "./OrdersSettingsTable.vue?vue&type=template&id=7f7b4d65&scoped=true"
import script from "./OrdersSettingsTable.vue?vue&type=script&lang=js"
export * from "./OrdersSettingsTable.vue?vue&type=script&lang=js"
import style0 from "./OrdersSettingsTable.vue?vue&type=style&index=0&id=7f7b4d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7b4d65",
  null
  
)

export default component.exports